import React from "react";
import { IconButtonProps, MenuItemProps } from "@mui/material";
import { ConfirmDialogProps } from "@common/components/Button/DeleteButton/dialog";

export enum SortDirections {
  ASC = "ASC",
  DESC = "DESC",
}

export interface SortObject<T extends string> {
  key: T;
  direction: SortDirections;
}

export interface TooltipButtonProps extends IconButtonProps {
  title?: string;
  onClick?: () => void;
}

export interface SelectOption<T extends MenuItemProps["value"]> {
  label: React.ReactNode;
  value: T;
}

export interface ControlsProps<T extends MenuItemProps["value"]> {
  DeleteDialogProps?: Pick<ConfirmDialogProps, "confirmPrompt" | "actionLabel">;
  deleteDisabled?: boolean;
  onDelete?: () => void;
  onAdd?: () => void;
  onRefresh?: () => void;
  onImport?: () => void;
  onSelect: (value: T) => void;
  canEdit?: boolean;
  options: SelectOption<T>[];
  selected: T;
  customAddTooltip?: string
}
